import {GeneralUtility} from './general-utility';

/**
 * Contains language related methods.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class LanguageUtility {
  private static _language: string;
  private static _languageId: number;
  private static _labels: { [key: string]: string };

  /**
   * Gets the ISO 639-1 language code.
   *
   * @returns {string}
   */
  public static get language(): string {
    if (LanguageUtility._language === undefined) {
      LanguageUtility._language = GeneralUtility.getGlobalProperty('language');
    }
    return LanguageUtility._language;
  }

  /**
   * Gets the language ID.
   *
   * @returns {number}
   */
  public static get languageId(): number {
    if (LanguageUtility._languageId === undefined) {
      LanguageUtility._languageId = parseInt(GeneralUtility.getGlobalProperty('languageId'));
    }
    return LanguageUtility._languageId;
  }

  /**
   * Gets the language labels.
   *
   * @returns {string}
   */
  public static get labels(): { [key: string]: string } {
    if (LanguageUtility._labels === undefined) {
      LanguageUtility._labels = GeneralUtility.getGlobalProperty('labels');
    }
    return LanguageUtility._labels;
  }

  /**
   * Translates a language label.
   *
   * @param {string} key Language key to translate
   * @returns {string}
   */
  public static translate(key: string): string {
    if (LanguageUtility.labels.hasOwnProperty(key)) {
      return LanguageUtility.labels[key];
    }
    return '';
  }
}
